
import _WsSpinner from './WsSpinner.vue.es.js'
import {app} from '../../core/main.es.js'
import {generateProxy} from '../../proxy.es.js'
import {uikitRenderer} from '../../core/HyperApp.es.js'
const WsSpinner = generateProxy(app, 'ws-spinner', _WsSpinner, uikitRenderer);
export default WsSpinner;
    